import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  animateToScreen,
  animateToScreenAndBeep,
} from '../../redux/ui/actions';
import backgroundImg from '../../assets/screens/screen-show-card.png';
import CardReaderScreen from '../../molecules/CardReaderScreen';
import PurchaseScreenContent from '../../molecules/PurchaseScreenContent';

class ExtraTicketPurchaseRC extends PureComponent {
  render() {
    const {
      currentZone,
      zones,
      passengers,
      goToConfirmationScreen,
      goBack,
      goToPassengersScreen,
    } = this.props;
    return (
      <CardReaderScreen backgroundImage={backgroundImg} fadeDuration="500ms">
        <PurchaseScreenContent
          currentZone={currentZone}
          ticketZones={zones}
          ticketPassengers={passengers}
          onBackButtonClick={goBack}
          onAddPassengersClick={goToPassengersScreen}
          onTicketAreaClick={goToConfirmationScreen}
        />
      </CardReaderScreen>
    );
  }
}

ExtraTicketPurchaseRC.propTypes = {
  goToConfirmationScreen: PropTypes.func.isRequired,
  goToPassengersScreen: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  currentZone: PropTypes.string.isRequired,
  zones: PropTypes.string.isRequired,
  passengers: PropTypes.number.isRequired,
};

const mapStateToProps = ({ cardReader }) => ({
  currentZone: cardReader.currentZone,
  zones: cardReader.extraTicket.zones,
  passengers: cardReader.extraTicket.passengers,
});

const mapDispatchToProps = (dispatch) => ({
  goBack: () => dispatch(animateToScreen('ExtraTicketRegion')),
  goToConfirmationScreen: () => dispatch(animateToScreenAndBeep('ExtraTicketConfirmation')), // eslint-disable-line
  goToPassengersScreen: () => dispatch(animateToScreen('ExtraTicketPassengers')),  // eslint-disable-line
});

// prettier-ignore
export default connect(mapStateToProps, mapDispatchToProps)(ExtraTicketPurchaseRC);
